import {useContext} from "react";
import Context from "./employeesContext";

const useEmployeesContext = () => useContext(Context);

export default useEmployeesContext;
